import React from "react";
import { Eye, UploadCloud, Share2 } from "lucide-react";
import { Field, iCls } from "../_shared";
import { resolveAssetDisplayUrl } from "../../../lib/assetUrl";
import { useAdminSettings } from "./AdminSettingsContext";

export default function AdminSettingsGlobal() {
  const ctx = useAdminSettings();
  return (
          <div className="space-y-6">
            <div className="overflow-hidden rounded-2xl border border-admin-border bg-admin-surface shadow-sm ring-1 ring-black/[0.03]">
              <div className="border-b border-admin-border bg-admin-muted/40 px-6 py-4">
                <div className="flex items-center justify-between gap-3">
                <h3 className="text-sm font-extrabold uppercase tracking-wider text-admin-text">Thông tin cơ bản</h3>
                <button
                  type="button"
                  onClick={() => ctx.setShowWebsitePreview(true)}
                  className="inline-flex items-center gap-2 rounded-xl border border-admin-border bg-admin-surface px-3 py-1.5 text-xs font-semibold text-admin-textMuted shadow-sm transition hover:border-admin-primary/25 hover:bg-admin-primaryLight hover:text-admin-primary"
                >
                  <Eye className="w-3.5 h-3.5" />
                  Preview header + favicon
                </button>
                </div>
              </div>
              <div className="p-6">
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                <Field label="Tên website">
                  <input type="text" className={iCls} value={ctx.data.siteName || ""} onChange={(e) => ctx.updateField("siteName", e.target.value)} placeholder="Lòng Vòng Đà Lạt" />
                </Field>
                <Field label="URL website">
                  <input type="url" className={iCls} value={ctx.data.siteUrl || ""} onChange={(e) => ctx.updateField("siteUrl", e.target.value)} placeholder="https://longvongdalat.com" />
                </Field>
                <Field label="Hotline">
                  <input type="text" className={iCls} value={ctx.data.hotline || ""} onChange={(e) => ctx.updateField("hotline", e.target.value)} placeholder="0900000000" />
                </Field>
                <Field label="Email liên hệ">
                  <input type="email" className={iCls} value={ctx.data.email || ""} onChange={(e) => ctx.updateField("email", e.target.value)} placeholder="contact@longvongdalat.com" />
                </Field>
                <Field label="Địa chỉ" className="sm:col-span-2">
                  <input type="text" className={iCls} value={ctx.data.address || ""} onChange={(e) => ctx.updateField("address", e.target.value)} placeholder="Đà Lạt, Lâm Đồng, Việt Nam" />
                </Field>
                <Field label="Tên người liên hệ">
                  <input type="text" className={iCls} value={ctx.data.contactPersonName || ""} onChange={(e) => ctx.updateField("contactPersonName", e.target.value)} placeholder="Lòng Vòng Đà Lạt" />
                </Field>
              </div>
              </div>
            </div>

            <div className="overflow-hidden rounded-2xl border border-admin-border bg-admin-surface shadow-sm ring-1 ring-black/[0.03]">
              <div className="border-b border-admin-border bg-admin-muted/40 px-6 py-4">
                <h3 className="text-sm font-extrabold uppercase tracking-wider text-admin-text">Logo / Favicon / OG Image</h3>
              </div>
              <div className="p-6">

              <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                {[
                  { key: "logo", label: "Logo", hint: "Hiển thị ở header & footer" },
                  { key: "favicon", label: "Favicon", hint: "Icon tab trình duyệt" },
                  { key: "ogImage", label: "OG Image", hint: "Ảnh chia sẻ Facebook/Zalo" },
                  { key: "background", label: "Background", hint: "Ảnh nền chung (nếu dùng)" },
                ].map((it) => {
                  const asset = ctx.data?.[it.key] || {};
                  const src = resolveAssetDisplayUrl(asset?.url, asset?.key);
                  const isUploading = ctx.uploadingField === it.key;
                  return (
                    <div key={it.key} className="rounded-xl border border-admin-border bg-admin-muted/30 p-4">
                      <div className="flex items-start justify-between gap-3">
                        <div>
                          <p className="font-bold text-admin-text">{it.label}</p>
                          <p className="mt-0.5 text-xs text-admin-textMuted">{it.hint}</p>
                        </div>
                        <label className={`relative cursor-pointer rounded-xl px-3 py-1.5 text-xs font-bold inline-flex items-center gap-1.5 shadow-sm transition ${
                          isUploading
                            ? "bg-admin-muted text-admin-textMuted cursor-not-allowed"
                            : "bg-admin-primary text-white hover:bg-admin-primaryHover"
                        }`}
                        style={isUploading ? {} : { boxShadow: "0 1px 0 rgba(0,0,0,0.18) inset, 0 3px 8px rgba(37,106,191,0.25)" }}>
                          <UploadCloud className="w-3.5 h-3.5" />
                          {isUploading ? "Đang upload..." : "Tải lên"}
                          <input type="file" className="sr-only" accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (!file) return;
                              if (it.key === "logo" || it.key === "favicon") {
                                ctx.setShowImageEdit({ field: it.key, file, title: `Chỉnh ${it.label} trước khi upload`, shape: it.key === "logo" ? "round" : "rect" });
                              } else {
                                ctx.handleAssetUpload(it.key, file);
                              }
                              e.target.value = "";
                            }}
                            disabled={isUploading}
                          />
                        </label>
                      </div>
                      <div className="mt-4">
                        {src ? (
                          <div className="overflow-hidden rounded-xl border border-admin-border bg-admin-surface">
                            <img src={src} alt={it.label} className="h-36 w-full object-contain bg-white" referrerPolicy="no-referrer" />
                          </div>
                        ) : (
                          <div className="flex h-36 items-center justify-center rounded-xl border border-dashed border-admin-border bg-admin-muted/40 text-sm text-admin-textMuted">
                            Chưa có {it.label.toLowerCase()}
                          </div>
                        )}
                        <div className="mt-3 flex flex-wrap gap-2">
                          <button type="button" onClick={() => ctx.setShowAssetPreview(it.key)} disabled={!src}
                            className="inline-flex items-center gap-1.5 rounded-xl border border-admin-border bg-admin-surface px-3 py-1.5 text-xs font-semibold text-admin-textMuted shadow-sm transition hover:border-admin-primary/25 hover:bg-admin-primaryLight hover:text-admin-primary disabled:opacity-50">
                            <Eye className="w-3.5 h-3.5" />
                            Preview
                          </button>
                        </div>
                        {(asset?.key || asset?.url) ? (
                          <div className="mt-2 text-[11px] text-admin-textMuted break-all">
                            <span className="font-medium">key:</span> {asset.key || "—"}<br />
                            <span className="font-medium">url:</span> {asset.url || "—"}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>
              </div>
            </div>

            <div className="overflow-hidden rounded-2xl border border-admin-border bg-admin-surface shadow-sm ring-1 ring-black/[0.03]">
              <div className="border-b border-admin-border bg-admin-muted/40 px-6 py-4">
                <div className="flex items-center justify-between gap-3">
                <h3 className="text-sm font-extrabold uppercase tracking-wider text-admin-text">Mạng xã hội</h3>
                <button
                  type="button"
                  onClick={() => ctx.setShowFooterPreview(true)}
                  className="inline-flex items-center gap-2 rounded-xl border border-admin-border bg-admin-surface px-3 py-1.5 text-xs font-semibold text-admin-textMuted shadow-sm transition hover:border-admin-primary/25 hover:bg-admin-primaryLight hover:text-admin-primary"
                >
                  <Share2 className="w-3.5 h-3.5" />
                  Preview footer
                </button>
                </div>
              </div>
              <div className="p-6">
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                <Field label="Facebook"><input type="url" className={iCls} value={ctx.data.facebook || ""} onChange={(e) => ctx.updateField("facebook", e.target.value)} placeholder="https://www.facebook.com/" /></Field>
                <Field label="Instagram"><input type="url" className={iCls} value={ctx.data.instagram || ""} onChange={(e) => ctx.updateField("instagram", e.target.value)} placeholder="https://www.instagram.com/" /></Field>
                <Field label="TikTok"><input type="url" className={iCls} value={ctx.data.tiktok || ""} onChange={(e) => ctx.updateField("tiktok", e.target.value)} placeholder="https://www.tiktok.com/" /></Field>
                <Field label="YouTube"><input type="url" className={iCls} value={ctx.data.youtube || ""} onChange={(e) => ctx.updateField("youtube", e.target.value)} placeholder="https://www.youtube.com/" /></Field>
              </div>
              </div>
            </div>

            <div className="overflow-hidden rounded-2xl border border-admin-border bg-admin-surface shadow-sm ring-1 ring-black/[0.03]">
              <div className="border-b border-admin-border bg-admin-muted/40 px-6 py-4">
                <h3 className="text-sm font-extrabold uppercase tracking-wider text-admin-text">SEO</h3>
              </div>
              <div className="space-y-5 p-6">
                <div>
                  <p className="mb-4 text-xs font-extrabold uppercase tracking-wider text-admin-textMuted">SEO mặc định</p>
                  <div className="space-y-4">
                    <Field label="Tiêu đề mặc định"><input type="text" className={iCls} value={ctx.data.seo?.defaultTitle || ""} onChange={(e) => ctx.updateField("seo.defaultTitle", e.target.value)} placeholder="Lòng Vòng Đà Lạt" /></Field>
                    <Field label="Mô tả mặc định"><textarea className={iCls} rows={3} value={ctx.data.seo?.defaultDescription || ""} onChange={(e) => ctx.updateField("seo.defaultDescription", e.target.value)} placeholder="Địa điểm, bản đồ và gợi ý du lịch Đà Lạt." /></Field>
                    <Field label="Từ khóa mặc định"><input type="text" className={iCls} value={(ctx.data.seo?.defaultKeywords || []).join(", ")} onChange={(e) => ctx.updateField("seo.defaultKeywords", e.target.value.split(",").map(k => k.trim()).filter(Boolean))} placeholder="da lat, du lich da lat, dia diem da lat" /></Field>
                    <div className="rounded-xl border border-admin-border bg-admin-muted/40 p-4">
                      <p className="mb-3 text-[10px] font-extrabold uppercase tracking-wider text-admin-textMuted">Organization (JSON-LD / SEO)</p>
                      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                        <Field label="Tên tổ chức"><input type="text" className={iCls} value={ctx.data.seo?.organization?.name || ""} onChange={(e) => ctx.updateField("seo.organization.name", e.target.value)} placeholder="Lòng Vòng Đà Lạt" /></Field>
                        <Field label="URL tổ chức"><input type="url" className={iCls} value={ctx.data.seo?.organization?.url || ""} onChange={(e) => ctx.updateField("seo.organization.url", e.target.value)} placeholder="https://longvongdalat.com" /></Field>
                        <Field label="Logo URL"><input type="url" className={iCls} value={ctx.data.seo?.organization?.logo || ""} onChange={(e) => ctx.updateField("seo.organization.logo", e.target.value)} placeholder="https://cdn.longvongdalat.com/site/logo/logo.png" /></Field>
                        <Field label="SameAs (phân tách bằng dấu phẩy)"><input type="text" className={iCls} value={(ctx.data.seo?.organization?.sameAs || []).join(", ")} onChange={(e) => ctx.updateField("seo.organization.sameAs", e.target.value.split(",").map((x) => x.trim()).filter(Boolean))} placeholder="https://facebook.com/..., https://instagram.com/..." /></Field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  );
}
